<template>
  <v-container class="modern-config-view pb-12">
    <!-- Premium Global Header -->
    <v-row class="mb-8 align-center px-4 pt-4">
      <div class="d-flex align-center">
        <v-avatar color="primary" size="48" class="mr-4 shadow-sm border-white-sm">
          <v-icon color="white">fas fa-users-cog</v-icon>
        </v-avatar>
        <div>
          <h1 class="text-h4 font-weight-black primary--text mb-0">Gestión de <span class="secondary--text">Usuarios</span></h1>
          <div class="caption grey--text font-weight-bold text-uppercase tracking-widest mt-1">Control de accesos, roles y permisos del sistema</div>
        </div>
      </div>
    </v-row>

    <v-card outlined class="modern-card elevation-0 overflow-hidden shadow-sm">
      <v-tabs 
        v-model="tab"
        background-color="grey lighten-5"
        color="primary"
        grow
        class="border-bottom"
      >
        <v-tab v-if="$can('read', 'User')" class="text-none font-weight-bold py-4">
          <v-icon left small>fas fa-user-friends</v-icon>
          Usuarios
        </v-tab>
        <v-tab v-if="$can('read', 'Role')" class="text-none font-weight-bold py-4">
          <v-icon left small>fas fa-user-shield</v-icon>
          Roles y Permisos
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item v-if="$can('read', 'User')" class="pa-0">
          <users-list />
        </v-tab-item>
        <v-tab-item v-if="$can('read', 'Role')" class="pa-0">
          <roles-list/>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>

<script>
import UsersList from '@/components/users/UsersList'
import RolesList from '@/components/users/RolesList'

export default {
  name: 'Users',
  components: {
    UsersList,
    RolesList
  },
  data() {
    return {
      tab: null,
    }
  },
}
</script>

<style scoped>
.modern-config-view { background-color: #f4f7f9; min-height: 100vh; }
.modern-card {
  border: 1px solid rgba(0,0,0,0.08) !important;
  border-radius: 12px !important;
  background-color: white !important;
}
.border-bottom { border-bottom: 1px solid rgba(0,0,0,0.08) !important; }
.text-none { text-transform: none !important; }
.tracking-widest { letter-spacing: 2px; }
.shadow-sm { box-shadow: 0 4px 12px rgba(0,0,0,0.04) !important; }
.border-white-sm { border: 2px solid white !important; }
</style>
